module.exports = __webpack_public_path__ + "static/media/LaBelleAurore-01.ff1a2b9d.svg";